module.exports = __webpack_public_path__ + "img/pin-barco.fc331b9d.png";